// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"b4044477","977":"7d178ef4"}[chunkId] + ".chunk.js";
};